<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
            <BackLink/>
            <Section :section="this.sectionId" />
        </div>                
        <Form
            :data="form"
            :error="$v.form.$error"
            :formId="question.id"
            :formErrorMessage="errorMessage"
            @submit="submitNameAndGender">
            <Fieldset 
                :title="question">
                <span id="hint" class="hint" v-if="hintText != null" v-html="hintText"></span>
                <TextInput
                    id="emailaddress"
                    name="emailaddress"
                    label="Email address"
                    :errorMessage="validationMsg($v.form.emailaddress) === ' is not a valid email address.' ? 'Email address'  + validationMsg($v.form.emailaddress) : '' +validationMsg($v.form.emailaddress)"
                    type="text"
                    v-model="form.emailaddress"
                    :validate="$v.form.emailaddress"
                />   
                <TextInput
                    id="confirmemail"
                    name="confirmemail"
                    label="Confirm email address"
                    type="text"
                    :errorMessage="'Confirm email address' + validationMsg($v.form.confirmemail)"
                    v-model="form.confirmemail"
                    :validate="$v.form.confirmemail"
                />   
                <div class="grid-row">
                    <div class="grid-col grid-xsmall-12 grid-large-6">
                        <TextInput
                            id="telephonehome"
                            name="telephonehome"
                            label="Telephone (home)"
                            type="number"
                            :errorMessage="validationMsg($v.form.telephonehome) !== 'Invalid' || !$v.form.telephonehome ? 'Telephone (home)'  + validationMsg($v.form.telephonehome) : ''"
                            v-model="form.telephonehome"
                            :validate="$v.form.telephonehome"
                        />   
                    </div>
                </div>

                <div class="grid-row">
                    <div class="grid-col grid-xsmall-12 grid-large-6">
                        <TextInput
                            id="telephonemobile"
                            name="telephonemobile"
                            label="Telephone (mobile)"
                            type="number"
                            :errorMessage="validationMsg($v.form.telephonemobile) !== 'Invalid' || !$v.form.telephonemobile ? 'Telephone (mobile)'  + validationMsg($v.form.telephonemobile) : ''"
                            v-model="form.telephonemobile"
                            :validate="$v.form.telephonemobile"
                        />
                    </div>
                </div>
                
                <div class="grid-row">
                    <div class="grid-col grid-xsmall-12 grid-large-6">
                        <TextInput
                            id="telephonework"
                            name="telephonework"
                            label="Telephone (work)"
                            type="number"
                            :errorMessage="validationMsg($v.form.telephonework) !== 'Invalid' || !$v.form.telephonework ? 'Telephone (work)'  + validationMsg($v.form.telephonework) : ''"
                            v-model="form.telephonework"
                            :validate="$v.form.telephonework"
                        />
                    </div>
                </div>
            </Fieldset>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>
import { helpers, requiredUnless, email, sameAs } from "vuelidate/lib/validators";
import { validationMessage } from 'vuelidate-messages';
import { dataService } from "../shared";
const validPhone = helpers.regex('phone', /^0([1-6][0-9]{8,10}|7[0-9]{9})$/)

const formMessages = {
    required: () => '',//' is a required field.',
    email: () => ' is not a valid email address.',
    sameAs: () => ' and Email address do not match',
    validPhone: () => ' must be a valid UK phone number.'
}

export default {
    name: "home",
    props: {
        title: String
    },
    data() {
        return {
            id: "",
            sectionId: null,
            question: "",
            hintText: "",
            errorMessage: "All fields are required",
            detailsTitle: "",
            destination: "",
            fieldErrors : {
                notrecognised: "This is not a recognized email address.",
                emailaddress : "Email address is a required field.",
                confirmemail : "Confirm email address is a required field.",
                confirmemailmatch : "Emails do not match.",
                telephonehome : "Telephone (home) is a required field.",
                telephonemobile : "Telephone (mobile) is a required field."
            },
            form: {
                emailaddress: '',
                confirmemail: '',
                telephonehome: null,
                telephonemobile: null,
                telephonework: null
            }
        };
    },
    created() {
        this.loadQuestion();
    },  
    mounted() {
        this.loadAnswer();
    },
    validations: {
        form: {
            emailaddress: {required: requiredUnless(function() {
                return (
                    this.form.telephonehome ||
                    this.form.telephonemobile ||
                    this.form.telephonework
                )
            }), email},
            confirmemail: {email, sameAs: sameAs('emailaddress')},
            telephonehome: {requiredIf: requiredUnless(function() {
                return (
                    this.form.emailaddress ||
                    this.form.telephonemobile ||
                    this.form.telephonework
                )
            }), validPhone},
            telephonemobile: {requiredIf: requiredUnless(function() {
                return (
                    this.form.emailaddress ||
                    this.form.telephonehome ||
                    this.form.telephonework
                )
            }), validPhone},
            telephonework: {requiredIf: requiredUnless(function() {
                return (
                    this.form.emailaddress ||
                    this.form.telephonehome ||
                    this.form.telephonemobile
                )
            }), validPhone}
        }
    },
    methods: {
        validationMsg: validationMessage(formMessages),
        submitForm(form, valid) {
            valid.$touch();
            if (valid.$pending || valid.$error) {
                this.formatErrorMessages(valid);
                setTimeout(() => {
                    document.querySelector(".error-summary__link").focus()
                }, 0);
                return;	
            }    
            this.logResponse();  
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: this.destination.toLowerCase() });
            }
        },
        submitNameAndGender() {
            this.submitForm(this.form, this.$v.form);
        },
        loadQuestion() {
            let json = dataService.getQuestions();
            let questions = json.questions;
            let currentQuestion = dataService.findElement(
                questions,
                dataService.parseUrl()
            );
            this.id = currentQuestion.id;
            this.sectionId = currentQuestion.sectionId;
            this.question = currentQuestion.question;
            this.hintText = currentQuestion.hintText;
            this.errorMessage = currentQuestion.errorMessage;
            this.destination = currentQuestion.destination;
            let previousResponse = dataService.wasAnsweredBefore(currentQuestion.id);
            if (previousResponse) {
                this.form.id = previousResponse.id;
                this.form.responseId = previousResponse.id;
                this.form.confirmemail = previousResponse.confirmemail;
                this.form.emailaddress = previousResponse.emailaddress;
                this.form.telephonehome = previousResponse.telephonehome;
                this.form.telephonemobile = previousResponse.telephonemobile;
                this.form.telephonework = previousResponse.telephonework;
                this.form.response = previousResponse.response;                
            }
        },    
        loadAnswer() {
        },
        logResponse() {
            let response = {
                id: this.id,
                questionType: "AddressDetails",
                confirmemail : this.form.confirmemail,
                emailaddress : this.form.emailaddress,
                telephonehome : this.form.telephonehome,
                telephonemobile : this.form.telephonemobile,
                telephonework : this.form.telephonework,
                responseId: this.answer,
                response: this.form.response
            };
            dataService.logResponse(response);
        },
        redirectToTimeout() {
            dataService.resetResponses();
            this.$router.push({ name: "timeout" });
        }
    }
};
</script>